export const PASSWORD_FORGOT_REQUEST = 'PASSWORD_FORGOT_REQUEST'
export const PASSWORD_FORGOT_SUCCESS = 'PASSWORD_FORGOT_SUCCESS'
export const PASSWORD_FORGOT_FAIL = 'PASSWORD_FORGOT_FAIL'

export const PASSWORD_UPDATE_REQUEST = 'PASSWORD_UPDATE_REQUEST'
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS'
export const PASSWORD_UPDATE_FAIL = 'PASSWORD_UPDATE_FAIL'
